import React from "react";
import ContactInfoWidget from "../Widget/ContactInfoWidget";
import MenuWidget from "../Widget/MenuWidget";
import SocialWidget from "../Widget/SocialWidget";
import Newsletter from "../Widget/Newsletter";
import TextWidget from "../Widget/TextWidget";
const menuDataOne = [
  { title: "Home", href: "" },
  { title: "Corporate", href: "/corporate" },
  { title: "About Us", href: "/about" },
  { title: "Our Product", href: "/productprotfoilio" },
  { title: "Privacy Policy", href: "/privacy-policy" },
  { title: "Terms & Condition", href: "/" },
  // { title: 'Testimonials', href: '/' },
];
const menuDataTwo = [
  { title: "Blog", href: "/blog" },
  { title: "Contact Us", href: "/contact" },
  { title: "FAQs", href: "/" },
  { title: "Privacy Policy", href: "/privacy-policy" },
  { title: "Terms and Conditions", href: "/" },
];
const currentYear = new Date().getFullYear();
export default function Footer() {
  return (
    <footer className="cs_footer cs_style_1 cs_heading_color">
      <div
        className="cs_footer_logo_wrap"
        style={{ backgroundImage: "url(/images/footer_bg_1.svg)" }}
      >
        <div
          className="cs_footer_brand"
          style={{ backgroundImage: "url(/images/footer_logo_bg.svg)" }}
          >
          <img
            src="/images/logo-white.svg"
            alt="Logo Icon"
            className="cs_footer_brand_icon"
          />
          {/* <h2 className="cs_footer_brand_text">Celbion</h2> */}
          {/* <p
            style={{
              fontSize: "12px",
              color: "#fff",
              marginLeft: "49px",
              marginBottom: "0",
            }}
          >
            HealthCare
          </p> */}
        </div>
      </div>
      <div className="cs_footer_main">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <TextWidget text="Celbion Healthcare is committed to advancing health and well-being through innovation, quality, and trust. Guided by our philosophy “Life Beyond Limits,” we strive to deliver reliable healthcare solutions that empower people to live healthier, stronger, and more fulfilling lives. " />
                <ContactInfoWidget />
              </div>
            </div>  
            <div className="col-lg-2">
              <div className="cs_footer_item">
                <MenuWidget data={menuDataOne} />
              </div>
            </div>
            <div className="col-lg-2">
              <div className="cs_footer_item">
                {/* <MenuWidget data={menuDataTwo} /> */}

                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m26!1m12!1m3!1d35146.29494212248!2d72.56057776482903!3d23.04468615722074!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m11!3e6!4m3!3m2!1d23.0293504!2d72.5778432!4m5!1s0x395e84742b76846f%3A0xf8c8ca73d3008402!2sSubhash%20Bridge%2C%20Ahmedabad%2C%20Gujarat!3m2!1d23.0617227!2d72.5856024!5e1!3m2!1sen!2sin!4v1766751517622!5m2!1sen!2sin"
                  width="250"
                  height="150"
                  style={{ border: "1px solid #254d4d", borderRadius: "6px" }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="cs_footer_item">
                <Newsletter
                  title="Be Our Subscribers"
                  subTitle="To get the latest news about health from our experts"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cs_footer_bottom cs_accent_bg">
        <div className="container">
          <div className="cs_footer_bottom_in">
            <SocialWidget />
            <div className="cs_copyright">
              Copyright © {currentYear} Celbion Healthcare. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
